export default __webpack_public_path__ + "static/media/Logo.b4513ad0.png";